'use strict';
module.exports = function (str) {
	return !isNaN(Date.parse(str));
};



//////////////////
// WEBPACK FOOTER
// ./~/vali-date/index.js
// module id = 4030
// module chunks = 0